// extracted by mini-css-extract-plugin
export default {"Icon":"hPPpPBDr","IconContainer":"ZoGCSrBJ","ButtonPlaceholder":"HtUqmFU3","ButtonSkeleton":"zfs5sZGQ","IconPlaceholder":"eZ2CHaFQ","CharacterCount":"KTkd5pGf"};